import React, { useState, useEffect } from "react";

// import JS files
import MuiModal from "../../mui/MuiModal";
import MuiButton from "../../mui/MuiButton";
import useFetch from "../../../context/useFetch";
// import Others files

const RejectDescriptionModal = ({
  width,
  isOverflow,
  isNotBackdropClick,
  openModal,
  setOpenModal,
  disableEscapeKeyDown = true,
  data,
  apiCall,
  // disableBackdropClick = true,
}) => {
  console.log("amin" , data)
  return (
    <>
      <MuiModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        width={width}
        isOverflow={isOverflow}
        isNotBackdropClick={isNotBackdropClick}
        disableEscapeKeyDown={disableEscapeKeyDown}
        // disableBackdropClick={disableBackdropClick}
      >
        <p className="text-myblack-100">{data.reject_description}</p>
      </MuiModal>
    </>
  );
};

export default RejectDescriptionModal;
